import React from "react";
import { createRoot } from "react-dom/client";
import "../scss/base.scss";
import Footer from ".";
import { FooterProps } from "./types";

const createFooter = (props: FooterProps) => {
  const footerContainer = document.getElementById("footer");

  if (footerContainer) {
    createRoot(footerContainer!).render(React.createElement(Footer, props));
  }
};

export { createFooter };
